import Messages from "./Messages";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import { messagesApi, messageTypeApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import classes from "./MessagesPage.module.css";
import { Filter, FilterExtention, FilterItem, Filters, FilterTypesEnum } from "../../../UI/Filter";
import MessageForm from "./MessageForm/MessageForm";
import BtnSelect from "../../../UI/Buttons/BtnSelect";
import moment from "moment";


const MessagesPage = () => {

    const { texts } = useSelector(state => state.translate);
    const applicationId = useSelector(state => state.application.applicationId);
    const uiData = useSelector((state) => state.general.uiData);
    const [messages, setMessages] = useState()

    const componentMounted = useRef(true);
    const dispatch = useDispatch()
    const [addPopapShow, setAddPopupShow] = useState();
    const [currentMessageData, setCurrentMessageData] = useState();
    const [iconList, setIconList] = useState();

    useEffect(() => {
        fetchMessages();
        fetchIcons();
        return () => {
            componentMounted.current = false;
        }
    }, [uiData])

    const fetchMessages = () => {
        if (uiData.bannerMessageTypeId) {
            const data = {
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId,
                expireDate: new Date(null),
                ignoreMessageTypesIds: [uiData.bannerMessageTypeId]
            }

            messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessagecontentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "MessagecontentMessagesFilterRange " + error.message, level: 2, component: "MessagesPage", line: 45 }))
                } else {
                    if (componentMounted.current) {
                        setMessages(resdata.map(m => {
                            // parse contents message to dict with lang keys
                            const parsecontents = m.contents?.reduce((obj, c) => { obj[c.lang] = c.content && JSON.parse(c.content); return obj }, {});
                            m.contents = parsecontents;
                            m.filtercontentsString = m.contents && JSON.stringify(m.contents);
                            m.filterDataString = `${m.expireDate && moment(m.expireDate).format("YY.MM.DD")} ${m.sentDate && moment(m.sentDate).format("YY.MM.DD")}`;
                            return m;
                        }));
                    }
                }
            })
        }
    }

    const fetchIcons = () => {
        messageTypeApi.messageTypeFilterRangePost((error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "MessagesPage", line: 66 }))
            } else {
                if (componentMounted.current) {
                    // temp not view 1 its bug and need to fix in api with filter
                    setIconList(resdata.filter(x => x.id !== 1));
                }
            }
        })
    }

    const deleteMessage = (e, id) => {
        e.stopPropagation();
        messagesApi.messagesDeleteIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "MessagesPage", line: 66 }))
            } else {
                if (componentMounted.current) {
                    setMessages(pre => pre.filter(m => m.id != id));
                }
            }
        })
    }

    const editMessage = (data) => {
        setCurrentMessageData({ data: data, title: texts.editMessage });
        setAddPopupShow(true);
    }

    const duplicateMessage = (e, data) => {
        e.stopPropagation();
        delete data.id;
        setCurrentMessageData({ data: data, title: texts.duplicateMessage });
        setAddPopupShow(true);
    }

    return <div className={classes.MessagesPage}>
        <div className={classes.CreateNew}>
            <BtnSelect checked={true} onClick={() => setAddPopupShow(true)} dropStyle={{ width: "114px", height: "30px", fontWeight: "700" }}>{texts.createNew}</BtnSelect>
            {addPopapShow && <MessageForm {...currentMessageData} iconList={iconList} setIconList={setIconList} onAdd={fetchMessages} onClose={() => { setAddPopupShow(false); setCurrentMessageData(null) }}></MessageForm>}
        </div>
        <FilterExtention list={messages}>
            <Filters>
                <Filter name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>
            </Filters>
            <FilterItem>
                <Messages editMessage={editMessage} duplicateMessage={duplicateMessage} deleteMessage={deleteMessage} ></Messages>
            </FilterItem>
        </FilterExtention>
    </div>
}
export default MessagesPage;